
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index6AC_DHyzNPUgwe0EjkfOJZspQD3UsleYXMg3HmuJhGAMeta } from "/home/runner/work/site-movimento/site-movimento/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93O0jkcABdOf3lbBQJOupZTsaJU8RaS0Or8f_RlBOr41QMeta } from "/home/runner/work/site-movimento/site-movimento/pages/[...slug].vue?macro=true";
import { default as indexZXQblXG6QOcoBRZP_hfuNdCwWSixBrSr4bRO7447NusMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93p__45xP3DoI9pItdmVgyx83O7Kn828jTxn3uqVbxnrSNgMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/[...slug].vue?macro=true";
import { default as _91tag_93TAtXO5LZlqt0FTGNMtkr_45K01tOIunqAgP1vonOZ2cQwMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/tags/[tag].vue?macro=true";
import { default as indexwPkQixVg7TxW9OWIceQR8Ux6spchNiPNsbrrWeaAPQYMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/tags/index.vue?macro=true";
import { default as indexeYzaHUMvN8Y5s_8NfG9UxSuwBMdQBzP5bgrTM1_ZFVcMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/dados/index.vue?macro=true";
import { default as index82RYDYAPdU4ClbyPzVTgAfplVfl26OwfP4_45lnNEZqGIMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/posts/index.vue?macro=true";
import { default as _91slug_93RAsKkl5ZhBf3amdiec_45Rifz4cNIP6dMfoopoejp2MQcMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/dados/[slug].vue?macro=true";
import { default as _91slug_932RiNQpUnl6H0_45a081r5sOjL6BsC6zpTf_WTf5iRTRiIMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/posts/[slug].vue?macro=true";
import { default as indexTRLk82H8E7NszyY0dcvz2MYrWmj1248zi9GQEM7QnLsMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/backend/index.vue?macro=true";
import { default as _91slug_938mhPgOWzxHIXFZc39MyJ0nQUHwLMEDOclH4wpwdJigIMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/backend/[slug].vue?macro=true";
import { default as indexu1YQjEMffQ3h6lCwUdi9QqAwAE2Pw4qv0aL9Vpehm5EMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/carreira/index.vue?macro=true";
import { default as _91slug_93WC_JzMXEL5_45AIwDmyj1mF24eunzV6u0DBW1H0KosM34Meta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/carreira/[slug].vue?macro=true";
import { default as index9Z65RinUf0Ws5IV6WRLin_6UU1gRoVXu46ih6BNW4pUMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/ferramentas/index.vue?macro=true";
import { default as _91slug_93pU7ZQJIf1Q6YfUpVRA9NcXGo1Ex2iuO6gnE_45m2zWn8oMeta } from "/home/runner/work/site-movimento/site-movimento/pages/blog/ferramentas/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/[...slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexZXQblXG6QOcoBRZP_hfuNdCwWSixBrSr4bRO7447NusMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    meta: _91_46_46_46slug_93p__45xP3DoI9pItdmVgyx83O7Kn828jTxn3uqVbxnrSNgMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/[...slug].vue")
  },
  {
    name: "blog-tags-tag",
    path: "/blog/tags/:tag()",
    meta: _91tag_93TAtXO5LZlqt0FTGNMtkr_45K01tOIunqAgP1vonOZ2cQwMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/tags/[tag].vue")
  },
  {
    name: "blog-tags",
    path: "/blog/tags",
    meta: indexwPkQixVg7TxW9OWIceQR8Ux6spchNiPNsbrrWeaAPQYMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/tags/index.vue")
  },
  {
    name: "blog-dados",
    path: "/blog/dados",
    meta: indexeYzaHUMvN8Y5s_8NfG9UxSuwBMdQBzP5bgrTM1_ZFVcMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/dados/index.vue")
  },
  {
    name: "blog-posts",
    path: "/blog/posts",
    meta: index82RYDYAPdU4ClbyPzVTgAfplVfl26OwfP4_45lnNEZqGIMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/posts/index.vue")
  },
  {
    name: "blog-dados-slug",
    path: "/blog/dados/:slug()",
    meta: _91slug_93RAsKkl5ZhBf3amdiec_45Rifz4cNIP6dMfoopoejp2MQcMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/dados/[slug].vue")
  },
  {
    name: "blog-posts-slug",
    path: "/blog/posts/:slug()",
    meta: _91slug_932RiNQpUnl6H0_45a081r5sOjL6BsC6zpTf_WTf5iRTRiIMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/posts/[slug].vue")
  },
  {
    name: "blog-backend",
    path: "/blog/backend",
    meta: indexTRLk82H8E7NszyY0dcvz2MYrWmj1248zi9GQEM7QnLsMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/backend/index.vue")
  },
  {
    name: "blog-backend-slug",
    path: "/blog/backend/:slug()",
    meta: _91slug_938mhPgOWzxHIXFZc39MyJ0nQUHwLMEDOclH4wpwdJigIMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/backend/[slug].vue")
  },
  {
    name: "blog-carreira",
    path: "/blog/carreira",
    meta: indexu1YQjEMffQ3h6lCwUdi9QqAwAE2Pw4qv0aL9Vpehm5EMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/carreira/index.vue")
  },
  {
    name: "blog-carreira-slug",
    path: "/blog/carreira/:slug()",
    meta: _91slug_93WC_JzMXEL5_45AIwDmyj1mF24eunzV6u0DBW1H0KosM34Meta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/carreira/[slug].vue")
  },
  {
    name: "blog-ferramentas",
    path: "/blog/ferramentas",
    meta: index9Z65RinUf0Ws5IV6WRLin_6UU1gRoVXu46ih6BNW4pUMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/ferramentas/index.vue")
  },
  {
    name: "blog-ferramentas-slug",
    path: "/blog/ferramentas/:slug()",
    meta: _91slug_93pU7ZQJIf1Q6YfUpVRA9NcXGo1Ex2iuO6gnE_45m2zWn8oMeta || {},
    component: () => import("/home/runner/work/site-movimento/site-movimento/pages/blog/ferramentas/[slug].vue")
  }
]